<div class="container">
  <h2>{{ 'communityList.title' | translate }}</h2>
  <ds-community-list></ds-community-list>
</div>
